import { configureStore } from '@reduxjs/toolkit'
import auth from './slices/auth-slice'
import map from './slices/map-slice'
import rinex from './slices/rinex-slice'
import { useSelector, TypedUseSelectorHook } from 'react-redux'

export const store = configureStore({
  reducer: { auth, map, rinex },
})

export type RootState = ReturnType<typeof store.getState>

export const useRootSelector: TypedUseSelectorHook<RootState> = useSelector
